export function makeLinksOpenInNewTab(containerSelector) {
  $(containerSelector).find('a').each(function() {
    const $link = $(this);

    if (!$link.attr('target')) {
      $link.attr('target', '_blank');
      const currentRel = $link.attr('rel') || '';

      if (!currentRel.includes('noopener')) {
        $link.attr('rel', currentRel ? `${currentRel} noopener noreferrer` : 'noopener noreferrer');
      }
    }
  });
}

